<a class="back-btn" (click)="goBack()" *ngIf="location === '2FA'">{{ 'general.back' | translate }}</a>
<ng-container *ngIf="location === '2FA'; else personalDetails">
  <h3 class="ui-headline">{{ (enabled2FA ? '2fa.disable.title' : '2fa.enable.title') | translate }}</h3>
</ng-container>
<ng-template #personalDetails>
  <h3 class="ui-headline">{{ '2fa.password_verification.title' | translate }}</h3>
</ng-template>
<p>{{ '2fa.password_verification.p' | translate }}</p>
<form [formGroup]="passwordForm">
  <div class="form-row" [ngClass]="{ invalid: submitted && passwordForm.get('password').invalid }">
    <label class="form-label">{{ '2fa.password_verification.currentPass' | translate }}</label>
    <input
      class="form-input password"
      formControlName="password"
      [type]="visible ? 'text' : 'password'"
      [placeholder]="'2fa.password_verification.currentPass' | translate"
      (keyup.enter)="send()"
    />
    <span
      (click)="visible = !visible"
      class="form-input-with-icon"
      [ngClass]="visible ? 'icon-i-visibility-on' : 'icon-i-visibility-off'"
    ></span>
  </div>
</form>
<!-- CTA -->
<button (click)="send()" class="ui-button" [class.loading]="loading">
  <span class="icon-i-windmill"></span>
  {{ (location === '2FA' ? 'general.next' : 'kids.verification_screen.cta') | translate }}
</button>
